import React, { createContext, useContext, useState } from 'react';

const defaultState = {
  isEmbedded: false,
  sdkVersion: '',
  interactiveDesignId: '',
  initialRoute: '/',
  hideDesignSidebar: false,
  hidePreviewButton: false,
  hideReadModeButton: false,
  hideDesignTemplateName: false,
};

const EmbeddingContext = createContext({
  embedState: defaultState,
  setEmbedState: () => {},
});

export const useEmbedding = () => useContext(EmbeddingContext);

const EmbeddingProvider = ({ children }) => {
  const [state, setState] = useState(defaultState);

  return (
    <EmbeddingContext.Provider value={{ embedState: state, setEmbedState: setState }}>
      {children}
    </EmbeddingContext.Provider>
  );
};

EmbeddingProvider.displayName = 'EmbeddingProvider';

export { EmbeddingProvider };
